import React from "react";
import { Typography } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import CustomCard from "../../blocks/Card/Card";

const { Title, Paragraph } = Typography;

const ValueGrowthComparisonChart = () => {
  const data = [
    {
      name: "Recent Growth",
      value: 3.31,
      fill: "#1890ff", // Ant Design blue
    },
    {
      name: "Forecasted Growth",
      value: 0.19,
      fill: "#52c41a", // Ant Design green
    },
    {
      name: "Potential Growth with Upgrades",
      value: 5.0,
      fill: "#faad14", // Ant Design gold
    },
  ];

  return (
    <CustomCard
      title={<Title level={4}>Value Growth Comparison</Title>}
      className="card-height"
    >
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis
            label={{
              value: "Growth Percentage",
              angle: -90,
              position: "insideLeft",
              style: { textAnchor: "middle" },
            }}
          />
          <Tooltip
            formatter={(value) => `${value.toFixed(2)}%`}
            labelStyle={{ color: "black" }}
            contentStyle={{
              backgroundColor: "white",
              border: "1px solid #d9d9d9",
              borderRadius: "2px",
            }}
          />
          <Legend />
          <Bar dataKey="value" name="Growth Rate" />
        </BarChart>
      </ResponsiveContainer>
      <Paragraph style={{ marginTop: 16, textAlign: "center" }}>
        This chart compares recent growth, forecasted growth, and potential
        growth with strategic upgrades. The potential growth is an estimate
        based on improving the lowest-scoring areas of the property.
      </Paragraph>
    </CustomCard>
  );
};

export default ValueGrowthComparisonChart;
